import { Dropdown, IDropdownOption } from "@fluentui/react";
import { dropdownStyles } from "../../common/views/DefaultStyles";
import { Utils } from "../../common/views/Utils";
import { OrderUtils } from "../../orders/views/shared/OrderUtils";
import { ProductUtils } from "../../products/ProductUtils";
import { AddCartItemModel, CartItemInfo } from "../models/CartModel";

export type CartItemProps = {
    item: CartItemInfo;
    onEdit: (item: CartItemInfo, newQty: number) => void;
    onDelete: (item: CartItemInfo) => void;
    qtyOptions: IDropdownOption[];
}

export default function CartItemView({ item, onEdit, onDelete, qtyOptions }: CartItemProps) {
    let url = ProductUtils.getImageUrl(item.product.imageUrl);
    let product = item.product;

    const width2 = Utils.getColumnWidth(2, 2, 3);
    const width10 = Utils.getColumnWidth(10, 10, 9);

    const onQtyChange = (event: React.FormEvent<HTMLDivElement>, option: any) => {
        const qty = option.key;

        if (qty > 0) {
            onEdit(item, qty);
        } else {
            onDelete(item);
        }
    }

    const qtyPicker = () => {
        return <>
            <Dropdown
                label=""
                selectedKey={item.qty}
                onChange={onQtyChange}
                options={qtyOptions}
                styles={{
                    root: { width: 60 },
                    title: {
                        height: 25,
                        lineHeight: 25
                    },
                    caretDownWrapper: {
                        height: 25,
                        lineHeight: 25
                    }
                }}
            />
        </>;
    }

    return <div className="ms-Grid-row font-smaller">
        <div className={width2 + " center"}>{OrderUtils.image(url, 0, 95, 0, false)}</div>
        <div className={width10 + " left"}>
            <div className="font-bold">{item.product.brand}</div>
            <div className="pt-5 limit-lines one-line">{item.product.productName}</div>
            <div className="pt-5 limit-lines one-line gray">
                {ProductUtils.getSubInfo(product.productName, product.size, product.code)}
            </div>
            <div className="pt-10">
                <div className={width2 + " pl-0"} style={{ paddingTop: 3 }}>
                    $ {item.product.salePrice.toFixed(2)}
                </div>
                <div className={width10 + " pr-0"}>{qtyPicker()}</div>
            </div>
        </div>
    </div>;
}